function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_14149_471672)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5199 2.96002H15.8999C15.9799 3.18002 16.0299 3.41002 16.0299 3.65002C16.0299 4.75002 15.1299 5.65002 14.0299 5.65002H9.2399C8.1399 5.65002 7.2399 4.75002 7.2399 3.65002C7.2399 3.41002 7.2899 3.17002 7.3699 2.96002H5.6499C4.5499 2.96002 3.6499 3.86002 3.6499 4.96002V19.57C3.6499 20.67 4.5499 21.57 5.6499 21.57H17.5199C18.6199 21.57 19.5199 20.67 19.5199 19.57V4.96002C19.5199 3.86002 18.6199 2.96002 17.5199 2.96002Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5601 7.88V12.26",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7501 10.07H12.3701",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8501 12.07C8.9501 12.07 9.8501 11.17 9.8501 10.07C9.8501 8.97001 8.9501 8.07001 7.8501 8.07001C6.7501 8.07001 5.8501 8.97001 5.8501 10.07C5.8501 11.17 6.7501 12.07 7.8501 12.07Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.38989 15.42H7.70989",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3899 15.42H16.7699",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.38989 18.49H7.70989",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3899 18.49H16.7699",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.03 1.65002H9.23999C8.13542 1.65002 7.23999 2.54545 7.23999 3.65002C7.23999 4.75459 8.13542 5.65002 9.23999 5.65002H14.03C15.1346 5.65002 16.03 4.75459 16.03 3.65002C16.03 2.54545 15.1346 1.65002 14.03 1.65002Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14149_471672"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.17,
  height: 21.22,
  fill: "white",
  transform: "translate(3 1)"
})));

var SvgRecords = function SvgRecords(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecords, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/records.8bfb477c.svg";
export { ForwardRef as ReactComponent };